import React, { useState } from "react";
import {
    AccordionRoot,
    AccordionItem,
    AccordionHeader,
    AccordionTrigger,
    AccordionPanel,
} from "@design-system/Accordion/Accordion";
import { TriangleIcon } from "@icons";
import { BooleanControl } from "./playgroundControls";
import { SandboxLayout } from "./SandboxLayout";
import { ShowcasePreview } from "./ShowcasePreview";
import styles from "./DatePickerPlayground.module.scss";
import accordionStyles from "./AccordionPlayground.module.scss";

const items = [
    {
        value: "overview",
        label: "Overview",
        content: "A short summary of the record's key details.",
    },
    {
        value: "activity",
        label: "Activity",
        content: "A timeline of recent changes and events.",
    },
    {
        value: "attachments",
        label: "Attachments",
        content: "Files and documents linked to this record.",
    },
] as const;

export const AccordionPlayground = () => {
    const [allowMultiple, setAllowMultiple] = useState(false);
    const [openValues, setOpenValues] = useState<string[]>(["overview"]);

    return (
        <SandboxLayout
            controls={
                <section>
                    <h2>Features</h2>
                    <div className={styles.booleanGrid}>
                        <BooleanControl
                            label="Allow multiple open"
                            checked={allowMultiple}
                            onChange={(checked) => {
                                setAllowMultiple(checked);
                                setOpenValues((current) =>
                                    checked ? current : current.slice(0, 1),
                                );
                            }}
                        />
                    </div>
                </section>
            }
        >
            <ShowcasePreview
                summary={`${allowMultiple ? "multiple" : "single"} open`}
                width="wide"
                output={JSON.stringify(openValues, null, 2)}
            >
                <div className={styles.surface}>
                    <AccordionRoot
                        multiple={allowMultiple}
                        value={openValues}
                        onValueChange={(value: string[]) =>
                            setOpenValues(value)
                        }
                    >
                        {items.map((item) => (
                            <AccordionItem
                                key={item.value}
                                value={item.value}
                                className={accordionStyles.item}
                            >
                                <AccordionHeader>
                                    <AccordionTrigger
                                        className={accordionStyles.trigger}
                                    >
                                        <TriangleIcon
                                            className={
                                                accordionStyles.triggerIcon
                                            }
                                        />
                                        {item.label}
                                    </AccordionTrigger>
                                </AccordionHeader>
                                <AccordionPanel>
                                    <div className={styles.panelContent}>
                                        {item.content}
                                    </div>
                                </AccordionPanel>
                            </AccordionItem>
                        ))}
                    </AccordionRoot>
                </div>
            </ShowcasePreview>
        </SandboxLayout>
    );
};
